export default "__VITE_ASSET__C8JUDmx5__"